"use strict";

exports.__esModule = true;
exports.default = ownerWindow;
var _ownerDocument = _interopRequireDefault(require("./ownerDocument"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Returns the owner window of a given element.
 * 
 * @param node the element
 */

function ownerWindow(node) {
  var doc = (0, _ownerDocument.default)(node);
  return doc && doc.defaultView || window;
}